module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_diamond__v_vector.e0cee26e.svg";